// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3JOc6","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__vKdLd"};